import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


let DomainSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_DOM_ID',
                id_ui: 'DOMAIN_ID',
                name:  'DOMAIN_NAME'},

    searchProviderFields: {
        WB_DOM_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
        DOMAIN_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        DOMAIN_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        DOMAIN_COMMENTS:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Comments', columnResourceName: 'colComments', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1333}},
        DOMAIN_EDIT_POLICY:       {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Edit Policy', columnResourceName: 'colComments', alignment: HorizAlignment.Center}, domainOptions: {}}
    },


  search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
    return new Promise<any[]>((resolve, error) => {

      let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
        'vUI_DOM_Search',
        this.searchProviderFields,
        [])

      PASearch.findByRequest(findRequest)
        .then((res: any[]) => {
          resolve(res)
        })
        .catch((err)=> {
          error(err)
        })
    })
  }

}


let DomainSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "DomainSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'DOMAIN_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'DOMAIN_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'DOMAIN_ID','DOMAIN_NAME','DOMAIN_COMMENTS','DOMAIN_EDIT_POLICY'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: DomainSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var DomainSearch: ISearch = {
    searchName: "Find Domain",
    renderOptions: { ui5ResourceId: "DomainSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [DomainSearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch("DomainBO", "Domain", DomainSearch, "Domain Search")

export {DomainSearch}
